import { render, staticRenderFns } from "./TabelaEndereco.vue?vue&type=template&id=1323da36&scoped=true"
import script from "./TabelaEndereco.vue?vue&type=script&lang=js"
export * from "./TabelaEndereco.vue?vue&type=script&lang=js"
import style0 from "./TabelaEndereco.vue?vue&type=style&index=0&id=1323da36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1323da36",
  null
  
)

export default component.exports